import { combineReducers } from 'redux';
import squaresReducer from './squares_reducer';
import levelReducer from './level_reducer';
import toolsReducer from './tools_reducer';
import goalReducer  from './goal_reducer';

const rootReducer = combineReducers({
  squares : squaresReducer,
  level   : levelReducer,
  tool    : toolsReducer,
  goal    : goalReducer,
})

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js